<template>
  <div>
    <label :for="idInner" v-if="libelleLong">
      <div class="d-flex mb-2">
        <div v-html="libelleLong"></div>
        <span class="ml-1 red--text" v-if="!optionel">*</span>
      </div>
    </label>

    <infobulle v-if="descriptionPopup" :descriptionPopup="descriptionPopup"> </infobulle>

    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
      <template v-slot:activator="{ on }">
        <v-text-field
          :style="{ width: largeurMaxEnPx }"
          v-bind="$attrs"
          :value="value?.substring(0, 10)"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          :rules="dateRules"
          v-on="on"
          clearable
          @input="handleInput"
          :dense="isDense"
          :outlined="isOutlined"
        ></v-text-field>
      </template>
      <v-date-picker :allowed-dates="allowedDates" :value="value?.substring(0, 10)" @input="dateSelected"></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import ChampBase from "@/components/ui/mixins/ChampBase"
export default {
  mixins: [ChampBase],
  props: {
    allowedDates: Function
  },
  data() {
    return {
      menu: false
    }
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event)
    },
    dateSelected(event) {
      this.menu = false
      this.handleInput(event)
    }
  },

  computed: {
    dateRules() {
      if (this.optionel) {
        return []
      }
      return [(v) => !!v || this.champObligatoireMessage]
    }
  }
}
</script>

<style scoped>
input[type="date"] {
  border: 1px solid #aaa;
  border-radius: 4px;
  padding: 3px;
}
input[type="date"]:hover,
input[type="date"]:focus {
  border: 1px solid #333;
  border-radius: 4px;
  padding: 3px;
}
</style>